export { default } from './DefaultCardRating';
